import React from 'react';
import ArmChairBottom from "./ArmChairBottom"

export default function BenchBottom(props) {
    return ArmChairBottom(props)
}